export default __webpack_public_path__ + "static/media/img-engine-room.2071bd3d.svg";